var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 8.98534C16.7579 13.2553 13.2756 16.747 9.00562 16.75C7.16141 16.7513 5.46741 16.1084 4.13619 15.034C3.79003 14.7546 3.76416 14.2358 4.07872 13.9213L4.43081 13.5692C4.69984 13.3002 5.12934 13.2707 5.42741 13.5072C6.40819 14.2855 7.64941 14.75 9 14.75C12.1783 14.75 14.75 12.1778 14.75 9C14.75 5.82172 12.1778 3.25 9 3.25C7.47456 3.25 6.08909 3.84278 5.06038 4.81037L6.64644 6.39644C6.96144 6.71144 6.73834 7.25 6.29291 7.25H1.75C1.47384 7.25 1.25 7.02616 1.25 6.75V2.20709C1.25 1.76166 1.78856 1.53856 2.10356 1.85353L3.64644 3.39641C5.03778 2.06675 6.9235 1.25 9 1.25C13.2753 1.25 16.7421 4.71187 16.75 8.98534ZM11.0965 11.4473L11.4035 11.0527C11.6578 10.7257 11.5989 10.2545 11.2719 10.0002L10 9.01091V5.75C10 5.33578 9.66422 5 9.25 5H8.75C8.33578 5 8 5.33578 8 5.75V9.98909L10.044 11.5789C10.371 11.8332 10.8422 11.7743 11.0965 11.4473Z",
    fill: "#004FC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.aa4af9e26deb4935775e7648a3c03dae.svg";
export { ForwardRef as ReactComponent };